export class IsUsingPasswordError extends Error {
  public constructor() {
    super()

    this.message = 'errors.isUsingPasswordError'
  }
}
